import { SdkApi } from './sdk/SdkApi';
import { PlatformizedApi } from './platform/PlatformizedApi';
import { listItemsParamsPrivateSchema, listItemsResultSchema } from '../zodSchemas.strict';
export class MediaManagerApi {
  constructor(settings) {
    this.settings = settings;
    this.platformizedApi = void 0;
    this.sdkApi = new SdkApi(this.settings.mediaManagerSDK);
    const {
      httpClient,
      source,
      namespace,
      onError
    } = this.settings;
    if (httpClient) {
      this.platformizedApi = new PlatformizedApi({
        httpClient,
        source,
        rawNamespace: namespace,
        onError
      });
    }
  }
  validate(schema, data, methodName) {
    const {
      experiments: {
        typeValidationEnabled
      },
      monitoring = {}
    } = this.settings;
    const {
      onParsingStarted,
      onParsingEnded
    } = monitoring;
    if (!typeValidationEnabled) {
      return;
    }
    try {
      onParsingStarted == null || onParsingStarted(methodName);
      schema.parse(data);
      onParsingEnded == null || onParsingEnded(methodName);
    } catch (error) {
      const zodError = error;
      const customError = new Error(`[Zod] ${methodName}`, {
        cause: zodError
      });
      if (this.settings.debug) {
        console.error(customError);
      }
      this.settings.onError(customError, data);
    }
  }
  async invokeApiMethod(methodName) {
    const {
      experiments: {
        platformizedApiEnabled
      },
      monitoring = {}
    } = this.settings;
    const {
      onPlatformizedRequest,
      onPlatformizedResponse
    } = monitoring;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (platformizedApiEnabled && this.platformizedApi) {
      try {
        onPlatformizedRequest == null || onPlatformizedRequest(methodName);
        const result = await this.platformizedApi[methodName](...args);
        onPlatformizedResponse == null || onPlatformizedResponse(methodName);
        return result;
      } catch (error) {
        if (this.settings.debug) {
          console.error('PlatformizedApi failed, fallback to SDK', {
            reason: error
          });
        }
        this.settings.onError(error);
      }
    }

    // fallback to SDK if platformizedApi is failed or disabled
    return this.sdkApi[methodName](...args);
  }
  async listItems(folderId, params) {
    const {
      source
    } = this.settings;
    if (source === 'private') {
      this.validate(listItemsParamsPrivateSchema, params, 'listItems');
      const result = await this.invokeApiMethod('listItems', folderId, params);
      this.validate(listItemsResultSchema, result, 'listItems');
      return result;
    }
    return this.sdkApi.listItems(folderId, params);
  }
}

// Sentry.extraErrorDataIntegration
// This integration extracts all non-native attributes from the error object and attaches them to the event as extra data.
// If the error object has a .toJSON() method, the ExtraErrorData integration will run it to extract additional information.
// https://docs.sentry.io/platforms/javascript/configuration/integrations/extraerrordata
//# sourceMappingURL=MediaManagerApi.js.map